var items = {
  "block.minecraft.air": "air",
  "block.minecraft.stone": "roche",
  "block.minecraft.granite": "granite",
  "block.minecraft.polished_granite": "granite poli",
  "block.minecraft.diorite": "diorite",
  "block.minecraft.polished_diorite": "diorite polie",
  "block.minecraft.andesite": "andésite",
  "block.minecraft.polished_andesite": "andésite polie",
  "block.minecraft.grass_block": "bloc d'herbe",
  "block.minecraft.dirt": "terre",
  "block.minecraft.coarse_dirt": "terre stérile",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "nylium carmin",
  "block.minecraft.warped_nylium": "nylium biscornu",
  "block.minecraft.cobblestone": "pierres",
  "block.minecraft.oak_planks": "planches de chêne",
  "block.minecraft.spruce_planks": "planches de sapin",
  "block.minecraft.birch_planks": "planches de bouleau",
  "block.minecraft.jungle_planks": "planches d'acajou",
  "block.minecraft.acacia_planks": "planches d'acacia",
  "block.minecraft.dark_oak_planks": "planches de chêne noir",
  "block.minecraft.crimson_planks": "planches carmin",
  "block.minecraft.warped_planks": "planches biscornues",
  "block.minecraft.oak_sapling": "pousse de chêne",
  "block.minecraft.spruce_sapling": "pousse de sapin",
  "block.minecraft.birch_sapling": "pousse de bouleau",
  "block.minecraft.jungle_sapling": "pousse d'acajou",
  "block.minecraft.acacia_sapling": "pousse d'acacia",
  "block.minecraft.dark_oak_sapling": "pousse de chêne noir",
  "block.minecraft.bedrock": "bedrock",
  "block.minecraft.sand": "sable",
  "block.minecraft.red_sand": "sable rouge",
  "block.minecraft.gravel": "gravier",
  "block.minecraft.gold_ore": "minerai d'or",
  "block.minecraft.iron_ore": "minerai de fer",
  "block.minecraft.coal_ore": "minerai de charbon",
  "block.minecraft.nether_gold_ore": "minerai d'or du nether",
  "block.minecraft.oak_log": "bûche de chêne",
  "block.minecraft.spruce_log": "bûche de sapin",
  "block.minecraft.birch_log": "bûche de bouleau",
  "block.minecraft.jungle_log": "bûche d'acajou",
  "block.minecraft.acacia_log": "bûche d'acacia",
  "block.minecraft.dark_oak_log": "bûche de chêne noir",
  "block.minecraft.crimson_stem": "tige carmin",
  "block.minecraft.warped_stem": "tige biscornue",
  "block.minecraft.stripped_oak_log": "bûche de chêne écorcée",
  "block.minecraft.stripped_spruce_log": "bûche de sapin écorcée",
  "block.minecraft.stripped_birch_log": "bûche de bouleau écorcée",
  "block.minecraft.stripped_jungle_log": "bûche d'acajou écorcée",
  "block.minecraft.stripped_acacia_log": "bûche d'acacia écorcée",
  "block.minecraft.stripped_dark_oak_log": "bûche de chêne noir écorcée",
  "block.minecraft.stripped_crimson_stem": "tige carmin dénudée",
  "block.minecraft.stripped_warped_stem": "tige biscornue dénudée",
  "block.minecraft.stripped_oak_wood": "bois de chêne écorcé",
  "block.minecraft.stripped_spruce_wood": "bois de sapin écorcé",
  "block.minecraft.stripped_birch_wood": "bois de bouleau écorcé",
  "block.minecraft.stripped_jungle_wood": "bois d'acajou écorcé",
  "block.minecraft.stripped_acacia_wood": "bois d'acacia écorcé",
  "block.minecraft.stripped_dark_oak_wood": "bois de chêne noir écorcé",
  "block.minecraft.stripped_crimson_hyphae": "hyphes carmin dénudées",
  "block.minecraft.stripped_warped_hyphae": "hyphes biscornues dénudées",
  "block.minecraft.oak_wood": "bois de chêne",
  "block.minecraft.spruce_wood": "bois de sapin",
  "block.minecraft.birch_wood": "bois de bouleau",
  "block.minecraft.jungle_wood": "bois d'acajou",
  "block.minecraft.acacia_wood": "bois d'acacia",
  "block.minecraft.dark_oak_wood": "bois de chêne noir",
  "block.minecraft.crimson_hyphae": "hyphes carmin",
  "block.minecraft.warped_hyphae": "hyphes biscornues",
  "block.minecraft.oak_leaves": "feuilles de chêne",
  "block.minecraft.spruce_leaves": "feuilles de sapin",
  "block.minecraft.birch_leaves": "feuilles de bouleau",
  "block.minecraft.jungle_leaves": "feuilles d'acajou",
  "block.minecraft.acacia_leaves": "feuilles d'acacia",
  "block.minecraft.dark_oak_leaves": "feuilles de chêne noir",
  "block.minecraft.sponge": "éponge",
  "block.minecraft.wet_sponge": "éponge mouillée",
  "block.minecraft.glass": "verre",
  "block.minecraft.lapis_ore": "minerai de lapis-lazuli",
  "block.minecraft.lapis_block": "bloc de lapis-lazuli",
  "block.minecraft.dispenser": "distributeur",
  "block.minecraft.sandstone": "grès",
  "block.minecraft.chiseled_sandstone": "grès sculpté",
  "block.minecraft.cut_sandstone": "grès taillé",
  "block.minecraft.note_block": "bloc musical",
  "block.minecraft.powered_rail": "rails de propulsion",
  "block.minecraft.detector_rail": "rails détecteurs",
  "block.minecraft.sticky_piston": "piston collant",
  "block.minecraft.cobweb": "toile d'araignée",
  "block.minecraft.grass": "herbe",
  "block.minecraft.fern": "fougère",
  "block.minecraft.dead_bush": "arbuste mort",
  "block.minecraft.seagrass": "herbe aquatique",
  "block.minecraft.sea_pickle": "cornichon de mer",
  "block.minecraft.piston": "piston",
  "block.minecraft.white_wool": "laine blanche",
  "block.minecraft.orange_wool": "laine orange",
  "block.minecraft.magenta_wool": "laine magenta",
  "block.minecraft.light_blue_wool": "laine bleu clair",
  "block.minecraft.yellow_wool": "laine jaune",
  "block.minecraft.lime_wool": "laine vert clair",
  "block.minecraft.pink_wool": "laine rose",
  "block.minecraft.gray_wool": "laine grise",
  "block.minecraft.light_gray_wool": "laine gris clair",
  "block.minecraft.cyan_wool": "laine cyan",
  "block.minecraft.purple_wool": "laine violette",
  "block.minecraft.blue_wool": "laine bleue",
  "block.minecraft.brown_wool": "laine marron",
  "block.minecraft.green_wool": "laine verte",
  "block.minecraft.red_wool": "laine rouge",
  "block.minecraft.black_wool": "laine noire",
  "block.minecraft.dandelion": "pissenlit",
  "block.minecraft.poppy": "coquelicot",
  "block.minecraft.blue_orchid": "orchidée bleue",
  "block.minecraft.allium": "allium",
  "block.minecraft.azure_bluet": "houstonie bleue",
  "block.minecraft.red_tulip": "tulipe rouge",
  "block.minecraft.orange_tulip": "tulipe orange",
  "block.minecraft.white_tulip": "tulipe blanche",
  "block.minecraft.pink_tulip": "tulipe rose",
  "block.minecraft.oxeye_daisy": "marguerite",
  "block.minecraft.cornflower": "bleuet",
  "block.minecraft.lily_of_the_valley": "muguet",
  "block.minecraft.wither_rose": "rose de wither",
  "block.minecraft.brown_mushroom": "champignon brun",
  "block.minecraft.red_mushroom": "champignon rouge",
  "block.minecraft.crimson_fungus": "champignon carmin",
  "block.minecraft.warped_fungus": "champignon biscornu",
  "block.minecraft.crimson_roots": "racines carmin",
  "block.minecraft.warped_roots": "racines biscornues",
  "block.minecraft.nether_sprouts": "germes du nether",
  "block.minecraft.weeping_vines": "lianes pleureuses",
  "block.minecraft.twisting_vines": "lianes tortueuses",
  "block.minecraft.sugar_cane": "canne à sucre",
  "block.minecraft.kelp": "algue",
  "block.minecraft.bamboo": "bambou",
  "block.minecraft.gold_block": "bloc d'or",
  "block.minecraft.iron_block": "bloc de fer",
  "block.minecraft.oak_slab": "dalle en chêne",
  "block.minecraft.spruce_slab": "dalle en sapin",
  "block.minecraft.birch_slab": "dalle en bouleau",
  "block.minecraft.jungle_slab": "dalle en acajou",
  "block.minecraft.acacia_slab": "dalle en acacia",
  "block.minecraft.dark_oak_slab": "dalle en chêne noir",
  "block.minecraft.crimson_slab": "dalle carmin",
  "block.minecraft.warped_slab": "dalle biscornue",
  "block.minecraft.stone_slab": "dalle de roche",
  "block.minecraft.smooth_stone_slab": "dalle de roche lisse",
  "block.minecraft.sandstone_slab": "dalle de grès",
  "block.minecraft.cut_sandstone_slab": "dalle en grès taillé",
  "block.minecraft.petrified_oak_slab": "dalle en chêne pétrifiée",
  "block.minecraft.cobblestone_slab": "dalle de pierres",
  "block.minecraft.brick_slab": "dalle en briques",
  "block.minecraft.stone_brick_slab": "dalle en pierre taillée",
  "block.minecraft.nether_brick_slab": "dalle en briques du nether",
  "block.minecraft.quartz_slab": "dalle de quartz",
  "block.minecraft.red_sandstone_slab": "dalle de grès rouge",
  "block.minecraft.cut_red_sandstone_slab": "dalle en grès rouge taillé",
  "block.minecraft.purpur_slab": "dalle de purpur",
  "block.minecraft.prismarine_slab": "dalle de prismarine",
  "block.minecraft.prismarine_brick_slab": "dalle de prismarine taillée",
  "block.minecraft.dark_prismarine_slab": "dalle de prismarine sombre",
  "block.minecraft.smooth_quartz": "bloc de quartz lisse",
  "block.minecraft.smooth_red_sandstone": "grès rouge lisse",
  "block.minecraft.smooth_sandstone": "grès lisse",
  "block.minecraft.smooth_stone": "roche lisse",
  "block.minecraft.bricks": "briques",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "bibliothèque",
  "block.minecraft.mossy_cobblestone": "pierres moussues",
  "block.minecraft.obsidian": "obsidienne",
  "block.minecraft.torch": "torche",
  "block.minecraft.end_rod": "barre de l'end",
  "block.minecraft.chorus_plant": "plante de chorus",
  "block.minecraft.chorus_flower": "fleur de chorus",
  "block.minecraft.purpur_block": "bloc de purpur",
  "block.minecraft.purpur_pillar": "pilier de purpur",
  "block.minecraft.purpur_stairs": "escalier de purpur",
  "block.minecraft.spawner": "générateur",
  "block.minecraft.oak_stairs": "escalier en chêne",
  "block.minecraft.chest": "coffre",
  "block.minecraft.diamond_ore": "minerai de diamant",
  "block.minecraft.diamond_block": "bloc de diamant",
  "block.minecraft.crafting_table": "établi",
  "block.minecraft.farmland": "terre labourée",
  "block.minecraft.furnace": "fourneau",
  "block.minecraft.ladder": "échelle",
  "block.minecraft.rail": "rails",
  "block.minecraft.cobblestone_stairs": "escalier en pierre",
  "block.minecraft.lever": "levier",
  "block.minecraft.stone_pressure_plate": "plaque de pression en pierre",
  "block.minecraft.oak_pressure_plate": "plaque de pression en chêne",
  "block.minecraft.spruce_pressure_plate": "plaque de pression en sapin",
  "block.minecraft.birch_pressure_plate": "plaque de pression en bouleau",
  "block.minecraft.jungle_pressure_plate": "plaque de pression en acajou",
  "block.minecraft.acacia_pressure_plate": "plaque de pression en acacia",
  "block.minecraft.dark_oak_pressure_plate": "plaque de pression en chêne noir",
  "block.minecraft.crimson_pressure_plate": "plaque de pression carmin",
  "block.minecraft.warped_pressure_plate": "plaque de pression biscornue",
  "block.minecraft.polished_blackstone_pressure_plate": "plaque de pression en pierre noire",
  "block.minecraft.redstone_ore": "minerai de redstone",
  "block.minecraft.redstone_torch": "torche de redstone",
  "block.minecraft.snow": "neige",
  "block.minecraft.ice": "glace",
  "block.minecraft.snow_block": "bloc de neige",
  "block.minecraft.cactus": "cactus",
  "block.minecraft.clay": "argile",
  "block.minecraft.jukebox": "jukebox",
  "block.minecraft.oak_fence": "barrière en chêne",
  "block.minecraft.spruce_fence": "barrière en sapin",
  "block.minecraft.birch_fence": "barrière en bouleau",
  "block.minecraft.jungle_fence": "barrière en acajou",
  "block.minecraft.acacia_fence": "barrière en acacia",
  "block.minecraft.dark_oak_fence": "barrière en chêne noir",
  "block.minecraft.crimson_fence": "barrière carmin",
  "block.minecraft.warped_fence": "barrière biscornue",
  "block.minecraft.pumpkin": "citrouille",
  "block.minecraft.carved_pumpkin": "citrouille sculptée",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "sable des âmes",
  "block.minecraft.soul_soil": "terre des âmes",
  "block.minecraft.basalt": "basalte",
  "block.minecraft.polished_basalt": "basalte poli",
  "block.minecraft.soul_torch": "torche des âmes",
  "block.minecraft.glowstone": "pierre lumineuse",
  "block.minecraft.jack_o_lantern": "citrouille-lanterne",
  "block.minecraft.oak_trapdoor": "trappe en chêne",
  "block.minecraft.spruce_trapdoor": "trappe en sapin",
  "block.minecraft.birch_trapdoor": "trappe en bouleau",
  "block.minecraft.jungle_trapdoor": "trappe en acajou",
  "block.minecraft.acacia_trapdoor": "trappe en acacia",
  "block.minecraft.dark_oak_trapdoor": "trappe en chêne noir",
  "block.minecraft.crimson_trapdoor": "trappe carmin",
  "block.minecraft.warped_trapdoor": "trappe biscornue",
  "block.minecraft.infested_stone": "roche infestée",
  "block.minecraft.infested_cobblestone": "pierres infestées",
  "block.minecraft.infested_stone_bricks": "pierre taillée infestée",
  "block.minecraft.infested_mossy_stone_bricks": "pierre taillée moussue infestée",
  "block.minecraft.infested_cracked_stone_bricks": "pierre taillée craquelée infestée",
  "block.minecraft.infested_chiseled_stone_bricks": "pierre sculptée infestée",
  "block.minecraft.stone_bricks": "pierre taillée",
  "block.minecraft.mossy_stone_bricks": "pierre taillée moussue",
  "block.minecraft.cracked_stone_bricks": "pierre taillée craquelée",
  "block.minecraft.chiseled_stone_bricks": "pierre sculptée",
  "block.minecraft.brown_mushroom_block": "bloc de champignon brun",
  "block.minecraft.red_mushroom_block": "bloc de champignon rouge",
  "block.minecraft.mushroom_stem": "tige de champignon",
  "block.minecraft.iron_bars": "barreaux de fer",
  "block.minecraft.chain": "chaîne",
  "block.minecraft.glass_pane": "vitre",
  "block.minecraft.melon": "pastèque",
  "block.minecraft.vine": "lianes",
  "block.minecraft.oak_fence_gate": "portillon en chêne",
  "block.minecraft.spruce_fence_gate": "portillon en sapin",
  "block.minecraft.birch_fence_gate": "portillon en bouleau",
  "block.minecraft.jungle_fence_gate": "portillon en acajou",
  "block.minecraft.acacia_fence_gate": "portillon en acacia",
  "block.minecraft.dark_oak_fence_gate": "portillon en chêne noir",
  "block.minecraft.crimson_fence_gate": "portillon carmin",
  "block.minecraft.warped_fence_gate": "portillon biscornu",
  "block.minecraft.brick_stairs": "escalier en briques",
  "block.minecraft.stone_brick_stairs": "escalier en pierre taillée",
  "block.minecraft.mycelium": "mycélium",
  "block.minecraft.lily_pad": "nénuphar",
  "block.minecraft.nether_bricks": "briques du nether",
  "block.minecraft.cracked_nether_bricks": "briques du nether craquelées",
  "block.minecraft.chiseled_nether_bricks": "briques du nether sculptées",
  "block.minecraft.nether_brick_fence": "barrière en briques du nether",
  "block.minecraft.nether_brick_stairs": "escalier en briques du nether",
  "block.minecraft.enchanting_table": "table d'enchantement",
  "block.minecraft.end_portal_frame": "cadre de portail de l'end",
  "block.minecraft.end_stone": "pierre de l'end",
  "block.minecraft.end_stone_bricks": "pierre taillée de l'end",
  "block.minecraft.dragon_egg": "oeuf de dragon",
  "block.minecraft.redstone_lamp": "lampe à redstone",
  "block.minecraft.sandstone_stairs": "escalier en grès",
  "block.minecraft.emerald_ore": "minerai d'émeraude",
  "block.minecraft.ender_chest": "coffre de l'ender",
  "block.minecraft.tripwire_hook": "crochet",
  "block.minecraft.emerald_block": "bloc d'émeraude",
  "block.minecraft.spruce_stairs": "escalier en sapin",
  "block.minecraft.birch_stairs": "escalier en bouleau",
  "block.minecraft.jungle_stairs": "escalier en acajou",
  "block.minecraft.crimson_stairs": "escalier carmin",
  "block.minecraft.warped_stairs": "escalier biscornu",
  "block.minecraft.command_block": "bloc de commande",
  "block.minecraft.beacon": "balise",
  "block.minecraft.cobblestone_wall": "muret de pierres",
  "block.minecraft.mossy_cobblestone_wall": "muret de pierres moussues",
  "block.minecraft.brick_wall": "muret en briques",
  "block.minecraft.prismarine_wall": "muret de prismarine",
  "block.minecraft.red_sandstone_wall": "muret en grès rouge",
  "block.minecraft.mossy_stone_brick_wall": "muret en pierre taillée moussue",
  "block.minecraft.granite_wall": "muret de granite",
  "block.minecraft.stone_brick_wall": "muret en pierre taillée",
  "block.minecraft.nether_brick_wall": "muret en briques du nether",
  "block.minecraft.andesite_wall": "muret d'andésite",
  "block.minecraft.red_nether_brick_wall": "muret en briques rouges du nether",
  "block.minecraft.sandstone_wall": "muret en grès",
  "block.minecraft.end_stone_brick_wall": "muret en pierre taillée de l'end",
  "block.minecraft.diorite_wall": "muret de diorite",
  "block.minecraft.blackstone_wall": "muret de roche noire",
  "block.minecraft.polished_blackstone_wall": "muret en pierre noire",
  "block.minecraft.polished_blackstone_brick_wall": "muret en pierre noire taillée",
  "block.minecraft.stone_button": "bouton en pierre",
  "block.minecraft.oak_button": "bouton en chêne",
  "block.minecraft.spruce_button": "bouton en sapin",
  "block.minecraft.birch_button": "bouton en bouleau",
  "block.minecraft.jungle_button": "bouton en acajou",
  "block.minecraft.acacia_button": "bouton en acacia",
  "block.minecraft.dark_oak_button": "bouton en chêne noir",
  "block.minecraft.crimson_button": "bouton carmin",
  "block.minecraft.warped_button": "bouton biscornu",
  "block.minecraft.polished_blackstone_button": "bouton en pierre noire",
  "block.minecraft.anvil": "enclume",
  "block.minecraft.chipped_anvil": "enclume ébréchée",
  "block.minecraft.damaged_anvil": "enclume endommagée",
  "block.minecraft.trapped_chest": "coffre piégé",
  "block.minecraft.light_weighted_pressure_plate": "plaque de pression pondérée légère",
  "block.minecraft.heavy_weighted_pressure_plate": "plaque de pression pondérée lourde",
  "block.minecraft.daylight_detector": "capteur de lumière",
  "block.minecraft.redstone_block": "bloc de redstone",
  "block.minecraft.nether_quartz_ore": "minerai de quartz du nether",
  "block.minecraft.hopper": "entonnoir",
  "block.minecraft.chiseled_quartz_block": "bloc de quartz sculpté",
  "block.minecraft.quartz_block": "bloc de quartz",
  "block.minecraft.quartz_bricks": "briques de quartz",
  "block.minecraft.quartz_pillar": "pilier de quartz",
  "block.minecraft.quartz_stairs": "escalier en quartz",
  "block.minecraft.activator_rail": "rails déclencheurs",
  "block.minecraft.dropper": "dropper",
  "block.minecraft.white_terracotta": "terre cuite blanche",
  "block.minecraft.orange_terracotta": "terre cuite orange",
  "block.minecraft.magenta_terracotta": "terre cuite magenta",
  "block.minecraft.light_blue_terracotta": "terre cuite bleu clair",
  "block.minecraft.yellow_terracotta": "terre cuite jaune",
  "block.minecraft.lime_terracotta": "terre cuite vert clair",
  "block.minecraft.pink_terracotta": "terre cuite rose",
  "block.minecraft.gray_terracotta": "terre cuite grise",
  "block.minecraft.light_gray_terracotta": "terre cuite gris clair",
  "block.minecraft.cyan_terracotta": "terre cuite cyan",
  "block.minecraft.purple_terracotta": "terre cuite violette",
  "block.minecraft.blue_terracotta": "terre cuite bleue",
  "block.minecraft.brown_terracotta": "terre cuite marron",
  "block.minecraft.green_terracotta": "terre cuite verte",
  "block.minecraft.red_terracotta": "terre cuite rouge",
  "block.minecraft.black_terracotta": "terre cuite noire",
  "block.minecraft.barrier": "barrière invisible",
  "block.minecraft.iron_trapdoor": "trappe en fer",
  "block.minecraft.hay_block": "botte de paille",
  "block.minecraft.white_carpet": "tapis blanc",
  "block.minecraft.orange_carpet": "tapis orange",
  "block.minecraft.magenta_carpet": "tapis magenta",
  "block.minecraft.light_blue_carpet": "tapis bleu clair",
  "block.minecraft.yellow_carpet": "tapis jaune",
  "block.minecraft.lime_carpet": "tapis vert clair",
  "block.minecraft.pink_carpet": "tapis rose",
  "block.minecraft.gray_carpet": "tapis gris",
  "block.minecraft.light_gray_carpet": "tapis gris clair",
  "block.minecraft.cyan_carpet": "tapis cyan",
  "block.minecraft.purple_carpet": "tapis violet",
  "block.minecraft.blue_carpet": "tapis bleu",
  "block.minecraft.brown_carpet": "tapis marron",
  "block.minecraft.green_carpet": "tapis vert",
  "block.minecraft.red_carpet": "tapis rouge",
  "block.minecraft.black_carpet": "tapis noir",
  "block.minecraft.terracotta": "terre cuite",
  "block.minecraft.coal_block": "bloc de charbon",
  "block.minecraft.packed_ice": "glace compactée",
  "block.minecraft.acacia_stairs": "escalier en acacia",
  "block.minecraft.dark_oak_stairs": "escalier en chêne noir",
  "block.minecraft.slime_block": "bloc de slime",
  "block.minecraft.grass_path": "chemin d'herbe",
  "block.minecraft.sunflower": "tournesol",
  "block.minecraft.lilac": "lilas",
  "block.minecraft.rose_bush": "rosier",
  "block.minecraft.peony": "pivoine",
  "block.minecraft.tall_grass": "hautes herbes",
  "block.minecraft.large_fern": "grande fougère",
  "block.minecraft.white_stained_glass": "verre blanc",
  "block.minecraft.orange_stained_glass": "verre orange",
  "block.minecraft.magenta_stained_glass": "verre magenta",
  "block.minecraft.light_blue_stained_glass": "verre bleu clair",
  "block.minecraft.yellow_stained_glass": "verre jaune",
  "block.minecraft.lime_stained_glass": "verre vert clair",
  "block.minecraft.pink_stained_glass": "verre rose",
  "block.minecraft.gray_stained_glass": "verre gris",
  "block.minecraft.light_gray_stained_glass": "verre gris clair",
  "block.minecraft.cyan_stained_glass": "verre cyan",
  "block.minecraft.purple_stained_glass": "verre violet",
  "block.minecraft.blue_stained_glass": "verre bleu",
  "block.minecraft.brown_stained_glass": "verre marron",
  "block.minecraft.green_stained_glass": "verre vert",
  "block.minecraft.red_stained_glass": "verre rouge",
  "block.minecraft.black_stained_glass": "verre noir",
  "block.minecraft.white_stained_glass_pane": "vitre blanche",
  "block.minecraft.orange_stained_glass_pane": "vitre orange",
  "block.minecraft.magenta_stained_glass_pane": "vitre magenta",
  "block.minecraft.light_blue_stained_glass_pane": "vitre bleu clair",
  "block.minecraft.yellow_stained_glass_pane": "vitre jaune",
  "block.minecraft.lime_stained_glass_pane": "vitre vert clair",
  "block.minecraft.pink_stained_glass_pane": "vitre rose",
  "block.minecraft.gray_stained_glass_pane": "vitre grise",
  "block.minecraft.light_gray_stained_glass_pane": "vitre gris clair",
  "block.minecraft.cyan_stained_glass_pane": "vitre cyan",
  "block.minecraft.purple_stained_glass_pane": "vitre violette",
  "block.minecraft.blue_stained_glass_pane": "vitre bleue",
  "block.minecraft.brown_stained_glass_pane": "vitre marron",
  "block.minecraft.green_stained_glass_pane": "vitre verte",
  "block.minecraft.red_stained_glass_pane": "vitre rouge",
  "block.minecraft.black_stained_glass_pane": "vitre noire",
  "block.minecraft.prismarine": "prismarine",
  "block.minecraft.prismarine_bricks": "prismarine taillée",
  "block.minecraft.dark_prismarine": "prismarine sombre",
  "block.minecraft.prismarine_stairs": "escalier en prismarine",
  "block.minecraft.prismarine_brick_stairs": "escalier en prismarine taillée",
  "block.minecraft.dark_prismarine_stairs": "escalier en prismarine sombre",
  "block.minecraft.sea_lantern": "lanterne aquatique",
  "block.minecraft.red_sandstone": "grès rouge",
  "block.minecraft.chiseled_red_sandstone": "grès rouge sculpté",
  "block.minecraft.cut_red_sandstone": "grès rouge taillé",
  "block.minecraft.red_sandstone_stairs": "escalier en grès rouge",
  "block.minecraft.repeating_command_block": "bloc de commande à répétition",
  "block.minecraft.chain_command_block": "bloc de commande en chaîne",
  "block.minecraft.magma_block": "bloc de magma",
  "block.minecraft.nether_wart_block": "bloc de verrues du nether",
  "block.minecraft.warped_wart_block": "bloc de verrues biscornues",
  "block.minecraft.red_nether_bricks": "briques rouges du nether",
  "block.minecraft.bone_block": "bloc d'os",
  "block.minecraft.structure_void": "vide de structure",
  "block.minecraft.observer": "observateur",
  "block.minecraft.shulker_box": "boîte de shulker",
  "block.minecraft.white_shulker_box": "boîte de shulker blanche",
  "block.minecraft.orange_shulker_box": "boîte de shulker orange",
  "block.minecraft.magenta_shulker_box": "boîte de shulker magenta",
  "block.minecraft.light_blue_shulker_box": "boîte de shulker bleu clair",
  "block.minecraft.yellow_shulker_box": "boîte de shulker jaune",
  "block.minecraft.lime_shulker_box": "boîte de shulker vert clair",
  "block.minecraft.pink_shulker_box": "boîte de shulker rose",
  "block.minecraft.gray_shulker_box": "boîte de shulker grise",
  "block.minecraft.light_gray_shulker_box": "boîte de shulker gris clair",
  "block.minecraft.cyan_shulker_box": "boîte de shulker cyan",
  "block.minecraft.purple_shulker_box": "boîte de shulker violette",
  "block.minecraft.blue_shulker_box": "boîte de shulker bleue",
  "block.minecraft.brown_shulker_box": "boîte de shulker marron",
  "block.minecraft.green_shulker_box": "boîte de shulker verte",
  "block.minecraft.red_shulker_box": "boîte de shulker rouge",
  "block.minecraft.black_shulker_box": "boîte de shulker noire",
  "block.minecraft.white_glazed_terracotta": "terre cuite émaillée blanche",
  "block.minecraft.orange_glazed_terracotta": "terre cuite émaillée orange",
  "block.minecraft.magenta_glazed_terracotta": "terre cuite émaillée magenta",
  "block.minecraft.light_blue_glazed_terracotta": "terre cuite émaillée bleu clair",
  "block.minecraft.yellow_glazed_terracotta": "terre cuite émaillée jaune",
  "block.minecraft.lime_glazed_terracotta": "terre cuite émaillée vert clair",
  "block.minecraft.pink_glazed_terracotta": "terre cuite émaillée rose",
  "block.minecraft.gray_glazed_terracotta": "terre cuite émaillée grise",
  "block.minecraft.light_gray_glazed_terracotta": "terre cuite émaillée gris clair",
  "block.minecraft.cyan_glazed_terracotta": "terre cuite émaillée cyan",
  "block.minecraft.purple_glazed_terracotta": "terre cuite émaillée violette",
  "block.minecraft.blue_glazed_terracotta": "terre cuite émaillée bleue",
  "block.minecraft.brown_glazed_terracotta": "terre cuite émaillée marron",
  "block.minecraft.green_glazed_terracotta": "terre cuite émaillée verte",
  "block.minecraft.red_glazed_terracotta": "terre cuite émaillée rouge",
  "block.minecraft.black_glazed_terracotta": "terre cuite émaillée noire",
  "block.minecraft.white_concrete": "béton blanc",
  "block.minecraft.orange_concrete": "béton orange",
  "block.minecraft.magenta_concrete": "béton magenta",
  "block.minecraft.light_blue_concrete": "béton bleu clair",
  "block.minecraft.yellow_concrete": "béton jaune",
  "block.minecraft.lime_concrete": "béton vert clair",
  "block.minecraft.pink_concrete": "béton rose",
  "block.minecraft.gray_concrete": "béton gris",
  "block.minecraft.light_gray_concrete": "béton gris clair",
  "block.minecraft.cyan_concrete": "béton cyan",
  "block.minecraft.purple_concrete": "béton violet",
  "block.minecraft.blue_concrete": "béton bleu",
  "block.minecraft.brown_concrete": "béton marron",
  "block.minecraft.green_concrete": "béton vert",
  "block.minecraft.red_concrete": "béton rouge",
  "block.minecraft.black_concrete": "béton noir",
  "block.minecraft.white_concrete_powder": "béton blanc en poudre",
  "block.minecraft.orange_concrete_powder": "béton orange en poudre",
  "block.minecraft.magenta_concrete_powder": "béton magenta en poudre",
  "block.minecraft.light_blue_concrete_powder": "béton bleu clair en poudre",
  "block.minecraft.yellow_concrete_powder": "béton jaune en poudre",
  "block.minecraft.lime_concrete_powder": "béton vert clair en poudre",
  "block.minecraft.pink_concrete_powder": "béton rose en poudre",
  "block.minecraft.gray_concrete_powder": "béton gris en poudre",
  "block.minecraft.light_gray_concrete_powder": "béton gris clair en poudre",
  "block.minecraft.cyan_concrete_powder": "béton cyan en poudre",
  "block.minecraft.purple_concrete_powder": "béton violet en poudre",
  "block.minecraft.blue_concrete_powder": "béton bleu en poudre",
  "block.minecraft.brown_concrete_powder": "béton marron en poudre",
  "block.minecraft.green_concrete_powder": "béton vert en poudre",
  "block.minecraft.red_concrete_powder": "béton rouge en poudre",
  "block.minecraft.black_concrete_powder": "béton noir en poudre",
  "block.minecraft.turtle_egg": "oeuf de tortue",
  "block.minecraft.dead_tube_coral_block": "bloc de corail tubulaire mort",
  "block.minecraft.dead_brain_coral_block": "bloc de corail cerveau mort",
  "block.minecraft.dead_bubble_coral_block": "bloc de corail bulles mort",
  "block.minecraft.dead_fire_coral_block": "bloc de corail de feu mort",
  "block.minecraft.dead_horn_coral_block": "bloc de corail corné mort",
  "block.minecraft.tube_coral_block": "bloc de corail tubulaire",
  "block.minecraft.brain_coral_block": "bloc de corail cerveau",
  "block.minecraft.bubble_coral_block": "bloc de corail bulles",
  "block.minecraft.fire_coral_block": "bloc de corail de feu",
  "block.minecraft.horn_coral_block": "bloc de corail corné",
  "block.minecraft.tube_coral": "corail tubulaire",
  "block.minecraft.brain_coral": "corail cerveau",
  "block.minecraft.bubble_coral": "corail bulles",
  "block.minecraft.fire_coral": "corail de feu",
  "block.minecraft.horn_coral": "corail corné",
  "block.minecraft.dead_brain_coral": "corail cerveau mort",
  "block.minecraft.dead_bubble_coral": "corail bulles mort",
  "block.minecraft.dead_fire_coral": "corail de feu mort",
  "block.minecraft.dead_horn_coral": "corail corné mort",
  "block.minecraft.dead_tube_coral": "corail tubulaire mort",
  "block.minecraft.tube_coral_fan": "gorgone de corail tubulaire",
  "block.minecraft.brain_coral_fan": "gorgone de corail cerveau",
  "block.minecraft.bubble_coral_fan": "gorgone de corail bulles",
  "block.minecraft.fire_coral_fan": "gorgone de corail de feu",
  "block.minecraft.horn_coral_fan": "gorgone de corail corné",
  "block.minecraft.dead_tube_coral_fan": "gorgone de corail tubulaire morte",
  "block.minecraft.dead_brain_coral_fan": "gorgone de corail cerveau morte",
  "block.minecraft.dead_bubble_coral_fan": "gorgone de corail bulles morte",
  "block.minecraft.dead_fire_coral_fan": "gorgone de corail de feu morte",
  "block.minecraft.dead_horn_coral_fan": "gorgone de corail corné morte",
  "block.minecraft.blue_ice": "glace bleue",
  "block.minecraft.conduit": "conduit",
  "block.minecraft.polished_granite_stairs": "escalier en granite poli",
  "block.minecraft.smooth_red_sandstone_stairs": "escalier en grès rouge lisse",
  "block.minecraft.mossy_stone_brick_stairs": "escalier en pierre taillée moussue",
  "block.minecraft.polished_diorite_stairs": "escalier en diorite polie",
  "block.minecraft.mossy_cobblestone_stairs": "escalier en pierres moussues",
  "block.minecraft.end_stone_brick_stairs": "escalier en pierre taillée de l'end",
  "block.minecraft.stone_stairs": "escalier de roche",
  "block.minecraft.smooth_sandstone_stairs": "escalier en grès lisse",
  "block.minecraft.smooth_quartz_stairs": "escalier en quartz lisse",
  "block.minecraft.granite_stairs": "escalier de granite",
  "block.minecraft.andesite_stairs": "escalier d'andésite",
  "block.minecraft.red_nether_brick_stairs": "escalier en briques rouges du nether",
  "block.minecraft.polished_andesite_stairs": "escalier d'andésite polie",
  "block.minecraft.diorite_stairs": "escalier de diorite",
  "block.minecraft.polished_granite_slab": "dalle en granite poli",
  "block.minecraft.smooth_red_sandstone_slab": "dalle en grès rouge lisse",
  "block.minecraft.mossy_stone_brick_slab": "dalle en pierre taillée moussue",
  "block.minecraft.polished_diorite_slab": "dalle en diorite polie",
  "block.minecraft.mossy_cobblestone_slab": "dalle en pierres moussues",
  "block.minecraft.end_stone_brick_slab": "dalle en pierre taillée de l'end",
  "block.minecraft.smooth_sandstone_slab": "dalle en grès lisse",
  "block.minecraft.smooth_quartz_slab": "dalle en quartz lisse",
  "block.minecraft.granite_slab": "dalle de granite",
  "block.minecraft.andesite_slab": "dalle d'andésite",
  "block.minecraft.red_nether_brick_slab": "dalle en briques rouges du nether",
  "block.minecraft.polished_andesite_slab": "dalle d'andésite polie",
  "block.minecraft.diorite_slab": "dalle de diorite",
  "block.minecraft.scaffolding": "échafaudage",
  "block.minecraft.iron_door": "porte en fer",
  "block.minecraft.oak_door": "porte en chêne",
  "block.minecraft.spruce_door": "porte en sapin",
  "block.minecraft.birch_door": "porte en bouleau",
  "block.minecraft.jungle_door": "porte en acajou",
  "block.minecraft.acacia_door": "porte en acacia",
  "block.minecraft.dark_oak_door": "porte en chêne noir",
  "block.minecraft.crimson_door": "porte carmin",
  "block.minecraft.warped_door": "porte biscornue",
  "block.minecraft.repeater": "répéteur de redstone",
  "block.minecraft.comparator": "comparateur de redstone",
  "block.minecraft.structure_block": "bloc de structure",
  "block.minecraft.jigsaw": "bloc de puzzle",
  "item.minecraft.turtle_helmet": "carapace de tortue□□sur la tête :□+2 de points d'armure",
  "item.minecraft.scute": "écaille de tortue",
  "item.minecraft.iron_shovel": "pelle en fer□□dans la main principale :□+3.5 de points d'attaque□-3 de vitesse d'attaque",
  "item.minecraft.iron_pickaxe": "pioche en fer□□dans la main principale :□+3 de points d'attaque□-2.8 de vitesse d'attaque",
  "item.minecraft.iron_axe": "hache en fer□□dans la main principale :□+8 de points d'attaque□-3.1 de vitesse d'attaque",
  "item.minecraft.flint_and_steel": "briquet",
  "item.minecraft.apple": "pomme",
  "item.minecraft.bow": "arc",
  "item.minecraft.arrow": "flèche",
  "item.minecraft.coal": "charbon",
  "item.minecraft.charcoal": "charbon de bois",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "lingot de fer",
  "item.minecraft.gold_ingot": "lingot d'or",
  "item.minecraft.netherite_ingot": "lingot de netherite",
  "item.minecraft.netherite_scrap": "fragments de netherite",
  "item.minecraft.iron_sword": "épée en fer□□dans la main principale :□+5 de points d'attaque□-2.4 de vitesse d'attaque",
  "item.minecraft.wooden_sword": "épée en bois□□dans la main principale :□+3 de points d'attaque□-2.4 de vitesse d'attaque",
  "item.minecraft.wooden_shovel": "pelle en bois□□dans la main principale :□+1.5 de points d'attaque□-3 de vitesse d'attaque",
  "item.minecraft.wooden_pickaxe": "pioche en bois□□dans la main principale :□+1 de points d'attaque□-2.8 de vitesse d'attaque",
  "item.minecraft.wooden_axe": "hache en bois□□dans la main principale :□+6 de points d'attaque□-3.2 de vitesse d'attaque",
  "item.minecraft.stone_sword": "épée en pierre□□dans la main principale :□+4 de points d'attaque□-2.4 de vitesse d'attaque",
  "item.minecraft.stone_shovel": "pelle en pierre□□dans la main principale :□+2.5 de points d'attaque□-3 de vitesse d'attaque",
  "item.minecraft.stone_pickaxe": "pioche en pierre□□dans la main principale :□+2 de points d'attaque□-2.8 de vitesse d'attaque",
  "item.minecraft.stone_axe": "hache en pierre□□dans la main principale :□+8 de points d'attaque□-3.2 de vitesse d'attaque",
  "item.minecraft.diamond_sword": "épée en diamant□□dans la main principale :□+6 de points d'attaque□-2.4 de vitesse d'attaque",
  "item.minecraft.diamond_shovel": "pelle en diamant□□dans la main principale :□+4.5 de points d'attaque□-3 de vitesse d'attaque",
  "item.minecraft.diamond_pickaxe": "pioche en diamant□□dans la main principale :□+4 de points d'attaque□-2.8 de vitesse d'attaque",
  "item.minecraft.diamond_axe": "hache en diamant□□dans la main principale :□+8 de points d'attaque□-3 de vitesse d'attaque",
  "item.minecraft.stick": "bâton",
  "item.minecraft.bowl": "bol",
  "item.minecraft.mushroom_stew": "soupe de champignons",
  "item.minecraft.golden_sword": "épée en or□□dans la main principale :□+3 de points d'attaque□-2.4 de vitesse d'attaque",
  "item.minecraft.golden_shovel": "pelle en or□□dans la main principale :□+1.5 de points d'attaque□-3 de vitesse d'attaque",
  "item.minecraft.golden_pickaxe": "pioche en or□□dans la main principale :□+1 de points d'attaque□-2.8 de vitesse d'attaque",
  "item.minecraft.golden_axe": "hache en or□□dans la main principale :□+6 de points d'attaque□-3 de vitesse d'attaque",
  "item.minecraft.netherite_sword": "épée en netherite□□dans la main principale :□+7 de points d'attaque□-2.4 de vitesse d'attaque",
  "item.minecraft.netherite_shovel": "pelle en netherite□□dans la main principale :□+5.5 de points d'attaque□-3 de vitesse d'attaque",
  "item.minecraft.netherite_pickaxe": "pioche en netherite□□dans la main principale :□+5 de points d'attaque□-2.8 de vitesse d'attaque",
  "item.minecraft.netherite_axe": "hache en netherite□□dans la main principale :□+9 de points d'attaque□-3 de vitesse d'attaque",
  "item.minecraft.string": "ficelle",
  "item.minecraft.feather": "plume",
  "item.minecraft.gunpowder": "poudre à canon",
  "item.minecraft.wooden_hoe": "houe en bois□□dans la main principale :□-3 de vitesse d'attaque",
  "item.minecraft.stone_hoe": "houe en pierre□□dans la main principale :□-2 de vitesse d'attaque",
  "item.minecraft.iron_hoe": "houe en fer□□dans la main principale :□-1 de vitesse d'attaque",
  "item.minecraft.diamond_hoe": "houe en diamant□□dans la main principale :",
  "item.minecraft.golden_hoe": "houe en or□□dans la main principale :□-3 de vitesse d'attaque",
  "item.minecraft.netherite_hoe": "houe en netherite□□dans la main principale :",
  "item.minecraft.wheat_seeds": "graines de blé",
  "item.minecraft.wheat": "blé",
  "item.minecraft.bread": "pain",
  "item.minecraft.leather_helmet": "chapeau en cuir□□sur la tête :□+1 de points d'armure",
  "item.minecraft.leather_chestplate": "tunique en cuir□□sur le corps :□+3 de points d'armure",
  "item.minecraft.leather_leggings": "pantalon en cuir□□aux jambes :□+2 de points d'armure",
  "item.minecraft.leather_boots": "bottes en cuir□□aux pieds :□+1 de points d'armure",
  "item.minecraft.chainmail_helmet": "casque de mailles□□sur la tête :□+2 de points d'armure",
  "item.minecraft.chainmail_chestplate": "cotte de mailles□□sur le corps :□+5 de points d'armure",
  "item.minecraft.chainmail_leggings": "jambières de mailles□□aux jambes :□+4 de points d'armure",
  "item.minecraft.chainmail_boots": "bottes de mailles□□aux pieds :□+1 de points d'armure",
  "item.minecraft.iron_helmet": "casque en fer□□sur la tête :□+2 de points d'armure",
  "item.minecraft.iron_chestplate": "plastron en fer□□sur le corps :□+6 de points d'armure",
  "item.minecraft.iron_leggings": "jambières en fer□□aux jambes :□+5 de points d'armure",
  "item.minecraft.iron_boots": "bottes en fer□□aux pieds :□+2 de points d'armure",
  "item.minecraft.diamond_helmet": "casque en diamant□□sur la tête :□+3 de points d'armure□+2 de robustesse",
  "item.minecraft.diamond_chestplate": "plastron en diamant□□sur le corps :□+8 de points d'armure□+2 de robustesse",
  "item.minecraft.diamond_leggings": "jambières en diamant□□aux jambes :□+6 de points d'armure□+2 de robustesse",
  "item.minecraft.diamond_boots": "bottes en diamant□□aux pieds :□+3 de points d'armure□+2 de robustesse",
  "item.minecraft.golden_helmet": "casque en or□□sur la tête :□+2 de points d'armure",
  "item.minecraft.golden_chestplate": "plastron en or□□sur le corps :□+5 de points d'armure",
  "item.minecraft.golden_leggings": "jambières en or□□aux jambes :□+3 de points d'armure",
  "item.minecraft.golden_boots": "bottes en or□□aux pieds :□+1 de points d'armure",
  "item.minecraft.netherite_helmet": "casque en netherite□□sur la tête :□+3 de points d'armure□+3 de robustesse□+1 de résistance au recul",
  "item.minecraft.netherite_chestplate": "plastron en netherite□□sur le corps :□+8 de points d'armure□+3 de robustesse□+1 de résistance au recul",
  "item.minecraft.netherite_leggings": "jambières en netherite□□aux jambes :□+6 de points d'armure□+3 de robustesse□+1 de résistance au recul",
  "item.minecraft.netherite_boots": "bottes en netherite□□aux pieds :□+3 de points d'armure□+3 de robustesse□+1 de résistance au recul",
  "item.minecraft.flint": "silex",
  "item.minecraft.porkchop": "côtelette de porc crue",
  "item.minecraft.cooked_porkchop": "côtelette de porc cuite",
  "item.minecraft.painting": "tableau",
  "item.minecraft.golden_apple": "pomme dorée",
  "item.minecraft.enchanted_golden_apple": "pomme dorée enchantée",
  "block.minecraft.oak_sign": "pancarte en chêne",
  "block.minecraft.spruce_sign": "pancarte en sapin",
  "block.minecraft.birch_sign": "pancarte en bouleau",
  "block.minecraft.jungle_sign": "pancarte en acajou",
  "block.minecraft.acacia_sign": "pancarte en acacia",
  "block.minecraft.dark_oak_sign": "pancarte en chêne noir",
  "block.minecraft.crimson_sign": "pancarte carmin",
  "block.minecraft.warped_sign": "pancarte biscornue",
  "item.minecraft.bucket": "seau",
  "item.minecraft.water_bucket": "seau d'eau",
  "item.minecraft.lava_bucket": "seau de lave",
  "item.minecraft.minecart": "wagonnet",
  "item.minecraft.saddle": "selle",
  "item.minecraft.redstone": "poudre de redstone",
  "item.minecraft.snowball": "boule de neige",
  "item.minecraft.oak_boat": "bateau en chêne",
  "item.minecraft.leather": "cuir",
  "item.minecraft.milk_bucket": "seau de lait",
  "item.minecraft.pufferfish_bucket": "poisson-globe dans un seau",
  "item.minecraft.salmon_bucket": "saumon dans un seau",
  "item.minecraft.cod_bucket": "morue dans un seau",
  "item.minecraft.tropical_fish_bucket": "poisson tropical dans un seau",
  "item.minecraft.brick": "brique",
  "item.minecraft.clay_ball": "motte d'argile",
  "block.minecraft.dried_kelp_block": "bloc d'algues séchées",
  "item.minecraft.paper": "papier",
  "item.minecraft.book": "livre",
  "item.minecraft.slime_ball": "boule de slime",
  "item.minecraft.chest_minecart": "wagonnet de stockage",
  "item.minecraft.furnace_minecart": "wagonnet motorisé",
  "item.minecraft.egg": "oeuf",
  "item.minecraft.compass": "boussole",
  "item.minecraft.fishing_rod": "canne à pêche",
  "item.minecraft.clock": "montre",
  "item.minecraft.glowstone_dust": "poudre lumineuse",
  "item.minecraft.cod": "morue crue",
  "item.minecraft.salmon": "saumon cru",
  "item.minecraft.tropical_fish": "poisson tropical",
  "item.minecraft.pufferfish": "poisson-globe",
  "item.minecraft.cooked_cod": "morue cuite",
  "item.minecraft.cooked_salmon": "saumon cuit",
  "item.minecraft.ink_sac": "poche d'encre",
  "item.minecraft.red_dye": "teinture rouge",
  "item.minecraft.green_dye": "teinture verte",
  "item.minecraft.cocoa_beans": "fèves de cacao",
  "item.minecraft.lapis_lazuli": "lapis-lazuli",
  "item.minecraft.purple_dye": "teinture violette",
  "item.minecraft.cyan_dye": "teinture cyan",
  "item.minecraft.light_gray_dye": "teinture gris clair",
  "item.minecraft.gray_dye": "teinture grise",
  "item.minecraft.pink_dye": "teinture rose",
  "item.minecraft.lime_dye": "teinture vert clair",
  "item.minecraft.yellow_dye": "teinture jaune",
  "item.minecraft.light_blue_dye": "teinture bleu clair",
  "item.minecraft.magenta_dye": "teinture magenta",
  "item.minecraft.orange_dye": "teinture orange",
  "item.minecraft.bone_meal": "poudre d'os",
  "item.minecraft.blue_dye": "teinture bleue",
  "item.minecraft.brown_dye": "teinture marron",
  "item.minecraft.black_dye": "teinture noire",
  "item.minecraft.white_dye": "teinture blanche",
  "item.minecraft.bone": "os",
  "item.minecraft.sugar": "sucre",
  "block.minecraft.cake": "gâteau",
  "block.minecraft.white_bed": "lit blanc",
  "block.minecraft.orange_bed": "lit orange",
  "block.minecraft.magenta_bed": "lit magenta",
  "block.minecraft.light_blue_bed": "lit bleu clair",
  "block.minecraft.yellow_bed": "lit jaune",
  "block.minecraft.lime_bed": "lit vert clair",
  "block.minecraft.pink_bed": "lit rose",
  "block.minecraft.gray_bed": "lit gris",
  "block.minecraft.light_gray_bed": "lit gris clair",
  "block.minecraft.cyan_bed": "lit cyan",
  "block.minecraft.purple_bed": "lit violet",
  "block.minecraft.blue_bed": "lit bleu",
  "block.minecraft.brown_bed": "lit marron",
  "block.minecraft.green_bed": "lit vert",
  "block.minecraft.red_bed": "lit rouge",
  "block.minecraft.black_bed": "lit noir",
  "item.minecraft.cookie": "cookie",
  "item.minecraft.filled_map": "carte□#0",
  "item.minecraft.shears": "cisailles",
  "item.minecraft.melon_slice": "tranche de pastèque",
  "item.minecraft.dried_kelp": "algue séchée",
  "item.minecraft.pumpkin_seeds": "graines de citrouille",
  "item.minecraft.melon_seeds": "graines de pastèque",
  "item.minecraft.beef": "boeuf cru",
  "item.minecraft.cooked_beef": "steak",
  "item.minecraft.chicken": "poulet cru",
  "item.minecraft.cooked_chicken": "poulet rôti",
  "item.minecraft.rotten_flesh": "chair putréfiée",
  "item.minecraft.ender_pearl": "perle de l'ender",
  "item.minecraft.blaze_rod": "bâton de blaze",
  "item.minecraft.ghast_tear": "larme de ghast",
  "item.minecraft.gold_nugget": "pépite d'or",
  "item.minecraft.nether_wart": "verrues du nether",
  "item.minecraft.potion": "potion non fabricable□sans effet",
  "item.minecraft.glass_bottle": "fiole",
  "item.minecraft.spider_eye": "oeil d'araignée",
  "item.minecraft.fermented_spider_eye": "oeil d'araignée fermenté",
  "item.minecraft.blaze_powder": "poudre de blaze",
  "item.minecraft.magma_cream": "crème de magma",
  "block.minecraft.brewing_stand": "alambic",
  "block.minecraft.cauldron": "chaudron",
  "item.minecraft.ender_eye": "oeil de l'ender",
  "item.minecraft.glistering_melon_slice": "tranche de pastèque scintillante",
  "item.minecraft.bat_spawn_egg": "oeuf d'apparition de chauve-souris",
  "item.minecraft.bee_spawn_egg": "oeuf d'apparition d'abeille",
  "item.minecraft.blaze_spawn_egg": "oeuf d'apparition de blaze",
  "item.minecraft.cat_spawn_egg": "oeuf d'apparition de chat",
  "item.minecraft.cave_spider_spawn_egg": "oeuf d'apparition d'araignée venimeuse",
  "item.minecraft.chicken_spawn_egg": "oeuf d'apparition de poule",
  "item.minecraft.cod_spawn_egg": "oeuf d'apparition de morue",
  "item.minecraft.cow_spawn_egg": "oeuf d'apparition de vache",
  "item.minecraft.creeper_spawn_egg": "oeuf d'apparition de creeper",
  "item.minecraft.dolphin_spawn_egg": "oeuf d'apparition de dauphin",
  "item.minecraft.donkey_spawn_egg": "oeuf d'apparition d'âne",
  "item.minecraft.drowned_spawn_egg": "oeuf d'apparition de noyé",
  "item.minecraft.elder_guardian_spawn_egg": "oeuf d'apparition de grand gardien",
  "item.minecraft.enderman_spawn_egg": "oeuf d'apparition d'enderman",
  "item.minecraft.endermite_spawn_egg": "oeuf d'apparition d'endermite",
  "item.minecraft.evoker_spawn_egg": "oeuf d'apparition d'évocateur",
  "item.minecraft.fox_spawn_egg": "oeuf d'apparition de renard",
  "item.minecraft.ghast_spawn_egg": "oeuf d'apparition de ghast",
  "item.minecraft.guardian_spawn_egg": "oeuf d'apparition de gardien",
  "item.minecraft.hoglin_spawn_egg": "oeuf d'apparition de hoglin",
  "item.minecraft.horse_spawn_egg": "oeuf d'apparition de cheval",
  "item.minecraft.husk_spawn_egg": "oeuf d'apparition de zombie momifié",
  "item.minecraft.llama_spawn_egg": "oeuf d'apparition de lama",
  "item.minecraft.magma_cube_spawn_egg": "oeuf d'apparition de cube de magma",
  "item.minecraft.mooshroom_spawn_egg": "oeuf d'apparition de champimeuh",
  "item.minecraft.mule_spawn_egg": "oeuf d'apparition de mule",
  "item.minecraft.ocelot_spawn_egg": "oeuf d'apparition d'ocelot",
  "item.minecraft.panda_spawn_egg": "oeuf d'apparition de panda",
  "item.minecraft.parrot_spawn_egg": "oeuf d'apparition de perroquet",
  "item.minecraft.phantom_spawn_egg": "oeuf d'apparition de phantom",
  "item.minecraft.pig_spawn_egg": "oeuf d'apparition de cochon",
  "item.minecraft.piglin_spawn_egg": "oeuf d'apparition de piglin",
  "item.minecraft.pillager_spawn_egg": "oeuf d'apparition de pillard",
  "item.minecraft.polar_bear_spawn_egg": "oeuf d'apparition d'ours blanc",
  "item.minecraft.pufferfish_spawn_egg": "oeuf d'apparition de poisson-globe",
  "item.minecraft.rabbit_spawn_egg": "oeuf d'apparition de lapin",
  "item.minecraft.ravager_spawn_egg": "oeuf d'apparition de ravageur",
  "item.minecraft.salmon_spawn_egg": "oeuf d'apparition de saumon",
  "item.minecraft.sheep_spawn_egg": "oeuf d'apparition de mouton",
  "item.minecraft.shulker_spawn_egg": "oeuf d'apparition de shulker",
  "item.minecraft.silverfish_spawn_egg": "oeuf d'apparition de poisson d'argent",
  "item.minecraft.skeleton_spawn_egg": "oeuf d'apparition de squelette",
  "item.minecraft.skeleton_horse_spawn_egg": "oeuf d'apparition de cheval-squelette",
  "item.minecraft.slime_spawn_egg": "oeuf d'apparition de slime",
  "item.minecraft.spider_spawn_egg": "oeuf d'apparition d'araignée",
  "item.minecraft.squid_spawn_egg": "oeuf d'apparition de poulpe",
  "item.minecraft.stray_spawn_egg": "oeuf d'apparition de vagabond",
  "item.minecraft.strider_spawn_egg": "oeuf d'apparition d'arpenteur",
  "item.minecraft.trader_llama_spawn_egg": "oeuf d'apparition de lama de marchand",
  "item.minecraft.tropical_fish_spawn_egg": "oeuf d'apparition de poisson tropical",
  "item.minecraft.turtle_spawn_egg": "oeuf d'apparition de tortue",
  "item.minecraft.vex_spawn_egg": "oeuf d'apparition de vex",
  "item.minecraft.villager_spawn_egg": "oeuf d'apparition de villageois",
  "item.minecraft.vindicator_spawn_egg": "oeuf d'apparition de vindicateur",
  "item.minecraft.wandering_trader_spawn_egg": "oeuf d'apparition de marchand ambulant",
  "item.minecraft.witch_spawn_egg": "oeuf d'apparition de sorcière",
  "item.minecraft.wither_skeleton_spawn_egg": "oeuf d'apparition de wither squelette",
  "item.minecraft.wolf_spawn_egg": "oeuf d'apparition de loup",
  "item.minecraft.zoglin_spawn_egg": "oeuf d'apparition de zoglin",
  "item.minecraft.zombie_spawn_egg": "oeuf d'apparition de zombie",
  "item.minecraft.zombie_horse_spawn_egg": "oeuf d'apparition de cheval-zombie",
  "item.minecraft.zombie_villager_spawn_egg": "oeuf d'apparition de zombie-villageois",
  "item.minecraft.zombified_piglin_spawn_egg": "oeuf d'apparition de piglin zombifié",
  "item.minecraft.experience_bottle": "fiole d'expérience",
  "item.minecraft.fire_charge": "boule de feu",
  "item.minecraft.writable_book": "livre et plume",
  "item.minecraft.written_book": "livre écrit",
  "item.minecraft.emerald": "émeraude",
  "item.minecraft.item_frame": "cadre",
  "block.minecraft.flower_pot": "pot de fleurs",
  "item.minecraft.carrot": "carotte",
  "item.minecraft.potato": "pomme de terre",
  "item.minecraft.baked_potato": "pomme de terre cuite",
  "item.minecraft.poisonous_potato": "pomme de terre empoisonnée",
  "item.minecraft.map": "carte vierge",
  "item.minecraft.golden_carrot": "carotte dorée",
  "block.minecraft.skeleton_skull": "crâne de squelette",
  "block.minecraft.wither_skeleton_skull": "crâne de wither squelette",
  "block.minecraft.player_head": "tête de joueur",
  "block.minecraft.zombie_head": "tête de zombie",
  "block.minecraft.creeper_head": "tête de creeper",
  "block.minecraft.dragon_head": "tête de dragon",
  "item.minecraft.carrot_on_a_stick": "carotte sur un bâton",
  "item.minecraft.warped_fungus_on_a_stick": "champignon biscornu sur un bâton",
  "item.minecraft.nether_star": "étoile du nether",
  "item.minecraft.pumpkin_pie": "tarte à la citrouille",
  "item.minecraft.firework_rocket": "fusée de feu d'artifice",
  "item.minecraft.firework_star": "étoile de feu d'artifice",
  "item.minecraft.enchanted_book": "livre enchanté",
  "item.minecraft.nether_brick": "brique du nether",
  "item.minecraft.quartz": "quartz du nether",
  "item.minecraft.tnt_minecart": "wagonnet à tnt",
  "item.minecraft.hopper_minecart": "wagonnet à entonnoir",
  "item.minecraft.prismarine_shard": "éclat de prismarine",
  "item.minecraft.prismarine_crystals": "cristaux de prismarine",
  "item.minecraft.rabbit": "lapin cru",
  "item.minecraft.cooked_rabbit": "lapin cuit",
  "item.minecraft.rabbit_stew": "ragoût de lapin",
  "item.minecraft.rabbit_foot": "patte de lapin",
  "item.minecraft.rabbit_hide": "peau de lapin",
  "item.minecraft.armor_stand": "porte-armure",
  "item.minecraft.iron_horse_armor": "armure en fer pour cheval",
  "item.minecraft.golden_horse_armor": "armure en or pour cheval",
  "item.minecraft.diamond_horse_armor": "armure en diamant pour cheval",
  "item.minecraft.leather_horse_armor": "armure en cuir pour cheval",
  "item.minecraft.lead": "laisse",
  "item.minecraft.name_tag": "étiquette",
  "item.minecraft.command_block_minecart": "wagonnet avec bloc de commande",
  "item.minecraft.mutton": "mouton cru",
  "item.minecraft.cooked_mutton": "mouton cuit",
  "block.minecraft.white_banner": "bannière blanche",
  "block.minecraft.orange_banner": "bannière orange",
  "block.minecraft.magenta_banner": "bannière magenta",
  "block.minecraft.light_blue_banner": "bannière bleu clair",
  "block.minecraft.yellow_banner": "bannière jaune",
  "block.minecraft.lime_banner": "bannière vert clair",
  "block.minecraft.pink_banner": "bannière rose",
  "block.minecraft.gray_banner": "bannière grise",
  "block.minecraft.light_gray_banner": "bannière gris clair",
  "block.minecraft.cyan_banner": "bannière cyan",
  "block.minecraft.purple_banner": "bannière violette",
  "block.minecraft.blue_banner": "bannière bleue",
  "block.minecraft.brown_banner": "bannière marron",
  "block.minecraft.green_banner": "bannière verte",
  "block.minecraft.red_banner": "bannière rouge",
  "block.minecraft.black_banner": "bannière noire",
  "item.minecraft.end_crystal": "cristal de l'end",
  "item.minecraft.chorus_fruit": "chorus",
  "item.minecraft.popped_chorus_fruit": "chorus éclaté",
  "item.minecraft.beetroot": "betterave",
  "item.minecraft.beetroot_seeds": "graines de betterave",
  "item.minecraft.beetroot_soup": "soupe de betteraves",
  "item.minecraft.dragon_breath": "souffle de dragon",
  "item.minecraft.splash_potion": "potion jetable non fabricable□sans effet",
  "item.minecraft.spectral_arrow": "flèche spectrale",
  "item.minecraft.tipped_arrow": "flèche à effet non fabricable□sans effet",
  "item.minecraft.lingering_potion": "potion persistante non fabricable□sans effet",
  "item.minecraft.shield": "bouclier",
  "item.minecraft.elytra": "élytres",
  "item.minecraft.spruce_boat": "bateau en sapin",
  "item.minecraft.birch_boat": "bateau en bouleau",
  "item.minecraft.jungle_boat": "bateau en acajou",
  "item.minecraft.acacia_boat": "bateau en acacia",
  "item.minecraft.dark_oak_boat": "bateau en chêne noir",
  "item.minecraft.totem_of_undying": "totem d'immortalité",
  "item.minecraft.shulker_shell": "carapace de shulker",
  "item.minecraft.iron_nugget": "pépite de fer",
  "item.minecraft.knowledge_book": "livre des connaissances",
  "item.minecraft.debug_stick": "bâton de débogage",
  "item.minecraft.music_disc_13": "disque□c418 - 13",
  "item.minecraft.music_disc_cat": "disque□c418 - cat",
  "item.minecraft.music_disc_blocks": "disque□c418 - blocks",
  "item.minecraft.music_disc_chirp": "disque□c418 - chirp",
  "item.minecraft.music_disc_far": "disque□c418 - far",
  "item.minecraft.music_disc_mall": "disque□c418 - mall",
  "item.minecraft.music_disc_mellohi": "disque□c418 - mellohi",
  "item.minecraft.music_disc_stal": "disque□c418 - stal",
  "item.minecraft.music_disc_strad": "disque□c418 - strad",
  "item.minecraft.music_disc_ward": "disque□c418 - ward",
  "item.minecraft.music_disc_11": "disque□c418 - 11",
  "item.minecraft.music_disc_wait": "disque□c418 - wait",
  "item.minecraft.music_disc_pigstep": "disque□lena raine - pigstep",
  "item.minecraft.trident": "trident□□dans la main principale :□+8 de points d'attaque□-2.9 de vitesse d'attaque",
  "item.minecraft.phantom_membrane": "membrane de phantom",
  "item.minecraft.nautilus_shell": "coquille de nautile",
  "item.minecraft.heart_of_the_sea": "coeur de la mer",
  "item.minecraft.crossbow": "arbalète",
  "item.minecraft.suspicious_stew": "soupe suspecte",
  "block.minecraft.loom": "métier à tisser",
  "item.minecraft.flower_banner_pattern": "motif de bannière□fleur",
  "item.minecraft.creeper_banner_pattern": "motif de bannière□face de creeper",
  "item.minecraft.skull_banner_pattern": "motif de bannière□crâne",
  "item.minecraft.mojang_banner_pattern": "motif de bannière□symbole",
  "item.minecraft.globe_banner_pattern": "motif de bannière□globe",
  "item.minecraft.piglin_banner_pattern": "motif de bannière□groin",
  "block.minecraft.composter": "composteur",
  "block.minecraft.barrel": "tonneau",
  "block.minecraft.smoker": "fumoir",
  "block.minecraft.blast_furnace": "haut fourneau",
  "block.minecraft.cartography_table": "table de cartographie",
  "block.minecraft.fletching_table": "table d'archerie",
  "block.minecraft.grindstone": "meule",
  "block.minecraft.lectern": "pupitre",
  "block.minecraft.smithing_table": "table de forgeron",
  "block.minecraft.stonecutter": "tailleur de pierre",
  "block.minecraft.bell": "cloche",
  "block.minecraft.lantern": "lanterne",
  "block.minecraft.soul_lantern": "lanterne des âmes",
  "item.minecraft.sweet_berries": "baies sucrées",
  "block.minecraft.campfire": "feu de camp",
  "block.minecraft.soul_campfire": "feu de camp des âmes",
  "block.minecraft.shroomlight": "champilampe",
  "item.minecraft.honeycomb": "rayon de miel",
  "block.minecraft.bee_nest": "nid d'abeilles",
  "block.minecraft.beehive": "ruche",
  "item.minecraft.honey_bottle": "fiole de miel",
  "block.minecraft.honey_block": "bloc de miel",
  "block.minecraft.honeycomb_block": "bloc de rayon de miel",
  "block.minecraft.lodestone": "magnétite",
  "block.minecraft.netherite_block": "bloc de netherite",
  "block.minecraft.ancient_debris": "débris antiques",
  "block.minecraft.target": "cible",
  "block.minecraft.crying_obsidian": "obsidienne pleureuse",
  "block.minecraft.blackstone": "roche noire",
  "block.minecraft.blackstone_slab": "dalle de roche noire",
  "block.minecraft.blackstone_stairs": "escalier de roche noire",
  "block.minecraft.gilded_blackstone": "roche noire dorée",
  "block.minecraft.polished_blackstone": "pierre noire",
  "block.minecraft.polished_blackstone_slab": "dalle en pierre noire",
  "block.minecraft.polished_blackstone_stairs": "escalier en pierre noire",
  "block.minecraft.chiseled_polished_blackstone": "pierre noire sculptée",
  "block.minecraft.polished_blackstone_bricks": "pierre noire taillée",
  "block.minecraft.polished_blackstone_brick_slab": "dalle en pierre noire taillée",
  "block.minecraft.polished_blackstone_brick_stairs": "escalier en pierre noire taillée",
  "block.minecraft.cracked_polished_blackstone_bricks": "pierre noire taillée craquelée",
  "block.minecraft.respawn_anchor": "ancre de réapparition",
}
export const fr_fr = items; 
